import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { TourEvent } from '../entities/project-tour-ontour-event.entity';

type Params = {
  sequenceId: number;
};

type Result = TourEvent[];

export const getTourEvents = createAppAsyncThunk(
  'projectTourOntour/getTourEvents',
  async (
    params: Params,
    { extra: { projectTourOntourGateway, snackbarGateway } },
  ): Promise<Result> => {
    try {
      const events = await projectTourOntourGateway.getEvents(
        params.sequenceId,
      );
      return events;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetTourEvents.Message.error'));
}
